// src/components/dashboard/toolbar/DashboardToolbar.tsx
import React from "react";
import { Button } from "react-bootstrap";

type Props = {
  onAdd: () => void;
  onSave: () => void;
  saveStatus: string;
  canSave: boolean;
};

export default function DashboardToolbar({ onAdd, onSave, saveStatus, canSave }: Props) {
  return (
    <div className="d-flex gap-2 mb-3">
      <Button variant="primary" onClick={onAdd}>
        Ajouter un Widget
      </Button>

      <Button variant="success" onClick={onSave} disabled={!canSave}>
        Sauvegarder les Modifications
      </Button>

      {saveStatus && <span className="ms-2">{saveStatus}</span>}
    </div>
  );
}
